// extracted by mini-css-extract-plugin
export default {"name":"Controls_name__3E6dg","flexedControlBox":"Controls_flexedControlBox__rvzRx"};